import React, { Component } from 'react';
import _ from 'lodash';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import SearchDocumentForm from '../../components/documents/SearchDocumentForm';
import Loading from '../../components/Loading';
import { rowClassNameFormat, thaiDateFormatter, renderShowsTableTotal } from '../../utils/bootstrapTableFormatters';
import { MergeAttributes } from '../../components/FlatData';
import SimpleModal from '../../components/SimpleModal';

import WorkflowProcessHistory from '../../components/WorkflowProcessHistory';

import './stylesheets/SearchDocumentsPage.css';

import SearchDocumentStore from '../../stores/SearchDocumentStore';

class SearchDocumentsPage extends Component {
  constructor() {
    super()

    this.state = {
      isDataFetched: false,
      years: [],
      document_template_types: [],
      data: [],
      pagination: {},
      params: {},
      searchText: '',
      open: false,
      modal_form: "history"
    }

    this.typeFormatter = this.typeFormatter.bind(this);
    this.numberFormatter = this.numberFormatter.bind(this);
    this.documentType = this.documentType.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.redirectToShowDocumentPage = this.redirectToShowDocumentPage.bind(this);
    this.stateFormatter = this.stateFormatter.bind(this);
    this.onClose = this.onClose.bind(this);

    // Pagination and Search
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
  }

  componentDidMount() {
    SearchDocumentStore.request({
      method: 'POST',
      action: 'search',
      data: {}
    }).then((resp)=>{
      const data = _.get(resp.data, 'data', []);
      const included = _.get(resp.data, 'included', {});
      const pagination = _.get(resp.data, 'meta.pagination', {});

      this.setState({
        data: data,
        years: included.years,
        document_template_types: included.document_template_types,
        pagination: pagination
      });
    }).then(()=>{
      this.setState({isDataFetched: true});
    });
  }

  handleSubmit(params){
    this.setState({isDataFetched: false});
    
    SearchDocumentStore.request({
      method: 'POST',
      action: 'search',
      data: params
    }).then((resp)=>{
      const data = _.get(resp.data, 'data', []);
      const included = _.get(resp.data, 'included', {});
      const pagination = _.get(resp.data, 'meta.pagination', {});

      this.setState({
        data: data,
        years: included.years,
        document_template_types: included.document_template_types,
        pagination: pagination,
        params: params
      });
    }).then(()=>{
      this.setState({isDataFetched: true});
    });
  }

  typeFormatter(cell, row) {
    let type = 'รับ';
    if (cell === 'issue_numbers') { type = 'ส่ง'; }
    if (row.type_name === "คำสั่ง") { type = 'คำสั่ง'; }

    return (
      <div>{type}</div>
    )
  }

  numberFormatter(cell, row) {
    let number_format = row.number;
    if (row.type === 'receive_numbers') { number_format = row.issue_number }
    return (
      <div>{number_format}</div>
      
    )
  }

  documentType(cell, row) {
    const document_type = _.get(row.document_detail, 'document_template_type', '');
    return (
      <div>{document_type}</div>
    )
  }

  stateFormatter(cell, row) {
    let status = cell;
    if(row.type_name === "คำสั่ง" && cell === "เอกสารส่งออก"){ status = "จบการทำงานรอดำเนินการต่อไป" }

    return (
      <a href="#" onClick={this.openModal.bind(this, row.workflow_process_id)}>
        {status}
      </a>
    )
  }

  openModal(workflow_process_id, event){
    event.stopPropagation();

    this.setState({
      open: true,
      modal_form: "history",
      workflow_process_id: workflow_process_id,
    });
  }

  onClose(){
    this.setState({
      open: false,
      workflow_process_id: null
    });
  }

  _setTableOption(){ 
      if(this.state.isDataFetched){
            return "ไม่มีข้อมูล";
        }else{
            return <Loading />
        }
  }

  handlePageChange(page, sizePerPage){
    this.setState({isDataFetched: false, data: []});
    const { searchText } = this.state;

    let data = this.state.params;
    data = {...data, page: page, searchText: searchText}

    SearchDocumentStore.request({
      method: 'POST',
      action: 'search',
      data: data
    }).then((resp)=>{
      const data = _.get(resp.data, 'data', []);
      const pagination = _.get(resp.data, 'meta.pagination', {});

      this.setState({
        data: data,
        pagination: pagination
      });
    }).then(()=>{
      this.setState({isDataFetched: true});
    });
  }

  handleSearchChange(searchText){
    if (searchText.length === 1) { return }
    this.setState({isDataFetched: false, data: []});

    SearchDocumentStore.request({
      method: 'POST',
      action: 'search',
      data: {
        page: 1,
        searchText: searchText
      }
    }).then((resp)=>{
      const data = _.get(resp.data, 'data', []);
      const pagination = _.get(resp.data, 'meta.pagination', {});

      this.setState({
        data: data,
        pagination: pagination
      });
    }).then(()=>{
      this.setState({isDataFetched: true});
    });
  }

  redirectToShowDocumentPage(row, isSelected, e){
    // open new tab
    window.open(`/templates/documents/${row.document.id}/show/${row.document_template.id}/wp/${row.workflow_process_id}`);

    // redirect
    // this.props.history.push(`/templates/documents/${row.document.id}/show/${row.document_template.id}/wp/${row.workflow_process_id}`);
  }

  render(){
    const total_items_count = _.get(this.state.pagination, 'total_items_count', 0);
    const active_page = _.get(this.state.pagination, 'active_page', 1);

    const options = {
      sizePerPageList: [],
      sizePerPage: 20,
      page: active_page,
      noDataText: this._setTableOption(),
      onRowClick: this.redirectToShowDocumentPage,
      onPageChange: this.handlePageChange,
      onSearchChange: this.handleSearchChange,
      searchDelayTime: 500,
      paginationShowsTotal: renderShowsTableTotal
    };

    const { isDataFetched, years, document_template_types } = this.state;

    let data = [];
    if (this.state.isDataFetched) {
      data = MergeAttributes(this.state.data);
    }

		return (
			<div>
        <div className='form-group'>
          <SearchDocumentForm 
            isDataFetched={isDataFetched} 
            years={years}
            document_template_types={document_template_types}
            handleSubmit={this.handleSubmit} />
        </div>
        
        <div className="rui-searchdoc">
          <BootstrapTable 
            data={data}
            remote={ true }
            fetchInfo={{dataTotalSize: total_items_count}}
            search={ false }
            multiColumnSearch={ true }
            options={ options }
            striped
            hover
            pagination
            version='4'
            tableContainerClass={'table-sm'}
            trClassName={rowClassNameFormat}>
            <TableHeaderColumn isKey dataField='id' hidden></TableHeaderColumn>
            <TableHeaderColumn dataField="type" dataFormat={this.typeFormatter} width="50">รับ/ส่ง</TableHeaderColumn>
            <TableHeaderColumn dataField='code' dataSort={ true } width="70">เลขที่</TableHeaderColumn>
            <TableHeaderColumn dataField='number' dataFormat={this.numberFormatter} dataSort={ true } width="150">ที่</TableHeaderColumn>
            <TableHeaderColumn dataField='created_at' dataSort={ true } dataFormat={ thaiDateFormatter }>ลงวันที่</TableHeaderColumn>
            <TableHeaderColumn dataField='informee_name' columnTitle dataSort={ true }>เรียน</TableHeaderColumn>
            <TableHeaderColumn dataField='topic' columnTitle dataSort={ true }>เรื่อง</TableHeaderColumn>
            <TableHeaderColumn dataField='from_department' columnTitle dataSort={ true }>จาก</TableHeaderColumn>
            <TableHeaderColumn dataField='to_department' columnTitle dataSort={ true }>ถึง</TableHeaderColumn>
            <TableHeaderColumn dataField='operated_by_department_name' columnTitle dataSort={ true }>หน่วยงานที่ดำเนินการ</TableHeaderColumn>
            <TableHeaderColumn dataField='document_type' dataFormat={this.documentType} dataSort={ true }>ประเภทเอกสาร</TableHeaderColumn>
            <TableHeaderColumn dataField='current_state_name' dataSort={ true } dataFormat={this.stateFormatter}>สถานะ</TableHeaderColumn>
          </BootstrapTable>
        </div>

        <SimpleModal 
          isOpen={this.state.open}
          title={this.state.modal_title}
          size={'modal-lg'}
          showSubmitButton={false}
          onClose={this.onClose}>

            {this.state.modal_form === "history" && (
              <div>
                <WorkflowProcessHistory id={this.state.workflow_process_id} />

                <div className="modal-footer row">
                  <button type='button' className="btn btn-primary pointer" onClick={this.openFullScreenHistory}>ดูแบบเต็มหน้าจอ</button>
                  <button type='button' className="btn btn-secondary pointer" onClick={this.onClose}>ปิด</button>
                </div>
              </div>
            )}
        </SimpleModal>
			</div>
		)
	}
}

export default SearchDocumentsPage;


// WEBPACK FOOTER //
// ./src/pages/documents/SearchDocumentsPage.js